var notification = {
    config: {
        delay: 5*1000,
        bottomShift: 10
    },
    init: function(){
        var self = this,
            container = $('<div class="js-notification-container notification-container" />');

        self.selectors = {
            showNotofications: 'notification_show',
            action: 'js-notification__action',
            close: 'js-notification__close'
        };

        self.startId = 0;

        self.elements = {
            $body: $('body'),
            $window: $(window)
        };

        self.swigTemplates = swig.compile($('#tmpl-notification').html());
        self.elements.$body.append(container);
        self.elements.$container = $('.js-notification-container');
    },
    show: function(text, action){
        var self = this,
            data = {},
            message = '',
            notificationItem;
        
        if (Array.isArray && Array.isArray(text)) {
            text.forEach(function(currentValue, index, array){
                var separator = (index < array.length - 1) ? '<br>' : '';

                if (currentValue.tag != 'success') {
                    message += '<span class="notification__error">'
                }
                message += currentValue.message + separator;
                if (currentValue.tag == 'success') {
                    message += '</span>'
                }
            })
        } else {
            message = text;
        }

        // prepeare data
        data.message = message;
        data.id = self.startId;
        data.action = (action && typeof(action) == 'object') ? action.action : '';

        self.startId ++;
        // append template
         self.elements.$container.append(self.swigTemplates(data));
        
        var notificationId = '#notification-' + data.id,
            $notificationItem = $(notificationId),
            $closebtn = $notificationItem.find('.' + self.selectors.close),
            $actionBtn = data.action.length > 0 ? $notificationItem.find('.' + self.selectors.action) : null;

        if ($actionBtn && action.callback) {
            $actionBtn.on('click', function(){
                action.callback(action.args);
                self.hide(notificationId, 250);
            })
        }

        $closebtn.on('click', function(){
            self.hide(notificationId)
        });

        // show notification
        $notificationItem.addClass(self.selectors.showNotofications);

        self.hide(notificationId, self.config.delay);
    },
    hide: function(id, timeout){
        var self = this,
            $notificationItem = $(id);

        setTimeout(function(){
            if ($notificationItem.is('div:visible')) {
                $notificationItem.removeClass(self.selectors.showNotofications);
                setTimeout(function(){
                    $notificationItem.remove()
                },250)
            }
        }, timeout || 0)
    }
}
$(function(){
    notification.init();
});

